<div class="py-2 px-4 flex flex-column gap-2">
    <div class="flex flex-row justify-content-between p-2">
        <h5 class="title-text">{{ title }}</h5>
        @if (svgName) {
            <lib-svg-icon [svgName]="svgName" [svgHeight]="'24px'" [svgWidth]="'27px'"></lib-svg-icon>
        }
    </div>

    <h2 class="blue-text">
        @if (growth) {
            {{ value | currency:'USD':'symbol':'1.2-2' }}
        } @else {
            {{ value }}
        }
    </h2>

    @if (percentage) {
        <div class="flex flex-row align-items-center gap-2">
        <mat-progress-bar mode="determinate" [value]="percentage"></mat-progress-bar>
            <span class="blue-text">{{ percentage }}%</span>
        </div>
    } @else if (growth) {
        <div class="flex flex-row align-items-center gap-2">
            <span 
              [class.success-text]="growth > 0"
              [class.error-text]="growth < 0"
              [class.neutral-text]="growth === 0"
            >
            {{ growth > 0 ? '+' : growth < 0 ? '-' : '' }} {{ growth }}% from last month
            </span>
        </div>
    }
</div>

